import { EventIdentifier, type EventParams, FeatureTeamEvent, TrackingEventType, useAnalytics } from '@capsicum/common';
import { useMe } from '@capsicum/socios-core';
import { useCallback } from 'react';
import { match } from 'ts-pattern';

type Payload = {
	currencyID: string;
	type: 'click' | 'view';
};

export const useTopMovingTokensAnalytics = () => {
	const analytics = useAnalytics();

	const {
		isMeLoading,
		me: { vatCountry }
	} = useMe();

	const sendAnalytics = useCallback(
		({ currencyID, type }: Payload) => {
			if (isMeLoading || !vatCountry) return;

			const info = match<Payload['type'], [EventIdentifier, EventParams?] | undefined>(type)
				.with('view', () => [EventIdentifier.TopMovingTokenView])
				.with('click', () => [EventIdentifier.ButtonClicked, { text: 'top-moving-token' }])
				.otherwise(() => undefined);

			if (!info) return;

			const [eventID, payload = {}] = info;

			analytics.sendEvent(TrackingEventType.track, eventID, {
				...payload,
				currency: currencyID,
				extra_parameter: vatCountry,
				feature_team: FeatureTeamEvent.ORFT
			});
		},
		[analytics, vatCountry, isMeLoading]
	);

	return {
		isLoading: isMeLoading,
		sendAnalytics
	};
};
